import { BANNER_TYPES, validateBannerFile } from 'models/campaign-banners-model'

export const campaignBannerUpload = (values: any, props: any = {}) => {
  const errors: { banners: Record<string, string>[] } = { banners: [] }
  if (!values.banners?.length) return errors

  values.banners.forEach((bannerValues, idx) => {
    const bannerErrors: Record<string, any> = {}
    if (!bannerValues.title) bannerErrors.title = 'Title is required'

    if (props.existingBanners?.find(({ title }) => title === bannerValues.title)) {
      bannerErrors.title = 'Banner with this title already exists'
    }

    if (!bannerValues.height) bannerErrors.height = 'Height is required'

    if (!bannerValues.width) bannerErrors.width = 'Width is required'

    if (values.type === BANNER_TYPES.html5 && !bannerValues.file) {
      bannerErrors.file = 'File is required'
    }

    errors.banners[idx] = bannerErrors
  })

  return errors
}

export const campaignBannerEditForm = (values: any, props: any = {}) => {
  const errors: Record<string, any> = {}

  if (!values.title) errors.title = 'Title is required'

  if (!values.height) errors.height = 'Height is required'

  if (!values.width) errors.width = 'Width is required'

  if (props.type === BANNER_TYPES.html5 && !values.file) errors.file = 'File is required'

  if (values.file) {
    const fileError = validateBannerFile(values.file, values.type || props.type)
    if (fileError) errors.file = `File ${fileError}`
  }

  return errors
}
